import React from "react";
import EditableFormattedMessage from "./EditableFormattedMessage";
import ppeFullLogo from '../ressources/logo-with-text-green.svg';

// Table row definitions for "Coping impliquant autrui"
const copingOthersRows = [
  {
    strategy: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT",
    explanation: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_DESC",
    strengths: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_SOCIAL_SUPPORT_LIMITS",
    noteIndex: 6,
  },
  {
    strategy: "SCOPE_REPORT_COPING_EMPATHY_SEEKING",
    explanation: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_DESC",
    strengths: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_EMPATHY_SEEKING_LIMITS",
    noteIndex: 3,
  },
  {
    strategy: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION",
    explanation: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_DESC",
    strengths: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_STRENGTHS",
    limits: "SCOPE_REPORT_COPING_EMOTION_SUPPRESSION_LIMITS",
    noteIndex: 2,
  },
];

export default function EditCopingDefinitionsPages2({
  messagesData,
  locale,
  messages,
  updateMessage,
  graph,
  code,
  datePassed,
  keyPage,
  getThirdPosition, // Pass this as a prop if needed
}) {
  return (
    <div className="PageCharts-chart">
      <div className="header-logo-box">
        <img alt="ppe-logo" className="header-logo-img" src={ppeFullLogo} />
      </div>
      <div className="report-alt-page">
        <h1>
          <EditableFormattedMessage
            keys={messagesData}
            locale={locale}
            msgKey={graph.title}
            messages={messages}
            updateMessage={updateMessage}
          />
          <span className="inline font-16">
            {" "}
            -{" "}
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="DEFINITIONS"
              messages={messages}
              updateMessage={updateMessage}
            />
          </span>{" "}
          2
        </h1>
        <span className="coping-sub-title">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="SCOPE_REPORT_COPING_OTHERS_TITLE"
              messages={messages}
              updateMessage={updateMessage}
              defaultMessage="Coping impliquant autrui"
            />
          </b>
        </span>
        <br />
        <table className="coping-table-fullwidth-less">
          <thead>
            <tr className="coping-table-header">
              <th>
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRATEGY"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Stratégie de coping"
                />
              </th>
              <th className="th-2">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_EXPLANATION"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Explication"
                />
              </th>
              <th className="th-3">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_STRENGTHS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Forces"
                />
              </th>
              <th className="th-4">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_LIMITS"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Limites"
                />
              </th>
              <th className="th-7">
                <EditableFormattedMessage
                  keys={messagesData}
                  locale={locale}
                  msgKey="SCOPE_REPORT_COPING_NOTE"
                  messages={messages}
                  updateMessage={updateMessage}
                  defaultMessage="Note"
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {copingOthersRows.map((row, i) => (
              <tr className="coping-table-row" key={i}>
                <th>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strategy}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </th>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.explanation}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.strengths}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={row.limits}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
                <td>
                  <EditableFormattedMessage
                    keys={messagesData}
                    locale={locale}
                    msgKey={getThirdPosition ? getThirdPosition(graph.data[row.noteIndex]) : ""}
                    messages={messages}
                    updateMessage={updateMessage}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="pdf-footer">
        <EditableFormattedMessage
          keys={messagesData}
          locale={locale}
          msgKey="PAGE"
          messages={messages}
          updateMessage={updateMessage}
        />{" "}
        {keyPage + 2}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="CANDIDATE"
              messages={messages}
              updateMessage={updateMessage}
            />
          </b>
        </div>{" "}
        {code}
        <div className="pdf-footer-separator">
          <b>
            <EditableFormattedMessage
              keys={messagesData}
              locale={locale}
              msgKey="TEST_DATE"
              messages={messages}
              updateMessage={updateMessage}
            />
          </b>{" "}
          {datePassed}
        </div>
      </div>
    </div>
  );
}